module.exports = __webpack_public_path__ + "static/media/fondo.924d678a.png";